var map = {
	"./Background/Firecrackers.svg": 7714,
	"./Background/clean.svg": 1279,
	"./Background/fu.svg": 251,
	"./Background/lanterns.svg": 8799,
	"./Background/pattern1.svg": 5015,
	"./Background/pattern2.svg": 4212,
	"./Background/pattern3.svg": 1461,
	"./Background/pattern4.svg": 4282,
	"./Background/pattern5.svg": 8155,
	"./Background/pattern6.svg": 88,
	"./Background/pattern7.svg": 9097,
	"./Background/pattern8.svg": 5662,
	"./Background/pattern9.svg": 303,
	"./Base/1.svg": 7942,
	"./Base/QY-02.svg": 2830,
	"./Ear Ring/Firecrackers.svg": 1980,
	"./Ear Ring/Hoop.svg": 4116,
	"./Ear Ring/Stud.svg": 2692,
	"./Ear Ring/lanterns.svg": 4121,
	"./Ear/Attached.svg": 1042,
	"./Ear/Detached.svg": 2896,
	"./Eyebrows/Doubt.svg": 282,
	"./Eyebrows/Eyelashes Down-1.svg": 9835,
	"./Eyebrows/Eyelashes Down.svg": 8385,
	"./Eyebrows/Eyelashes Up.svg": 2206,
	"./Eyebrows/Up.svg": 3619,
	"./Eyebrows/dot.svg": 2729,
	"./Eyes/Disdain.svg": 2338,
	"./Eyes/Eyes.svg": 2648,
	"./Eyes/Eyeshadow.svg": 1478,
	"./Eyes/Large and small eyes.svg": 2241,
	"./Eyes/Round.svg": 3078,
	"./Eyes/Smiling.svg": 1099,
	"./Eyes/stare.svg": 8191,
	"./Facial Hair/Scruff.svg": 5043,
	"./Glasses/Round-1.svg": 6708,
	"./Glasses/Round.svg": 6638,
	"./Glasses/egg.svg": 97,
	"./Glasses/star.svg": 7734,
	"./Hair/Danny Phantom.svg": 6253,
	"./Hair/Double Ponytail.svg": 4315,
	"./Hair/Doug Funny.svg": 2907,
	"./Hair/Fonze.svg": 1182,
	"./Hair/Full.svg": 2319,
	"./Hair/Mr Clean.svg": 2978,
	"./Hair/Mr T.svg": 8521,
	"./Hair/Pixie.svg": 2125,
	"./Hair/QY-03.svg": 1208,
	"./Hair/QY-04.svg": 391,
	"./Hair/QY-05.svg": 6566,
	"./Hair/Short.svg": 1790,
	"./Hair/Turban.svg": 416,
	"./Hair/handsome.svg": 4159,
	"./Hair/大波浪.svg": 7287,
	"./Hair/爆炸头.svg": 9706,
	"./Hair/秃头.svg": 4149,
	"./Hair/齐刘海.svg": 167,
	"./Hat/Christmas.svg": 4673,
	"./Headwear/cowHorn.svg": 3094,
	"./Mask/3M.svg": 2184,
	"./Mask/Cyberpunk.svg": 7259,
	"./Mask/General.svg": 4172,
	"./Mouth/Frown.svg": 5779,
	"./Mouth/Laughing.svg": 8316,
	"./Mouth/Nervous.svg": 1,
	"./Mouth/Pucker.svg": 7351,
	"./Mouth/QY-01.svg": 6497,
	"./Mouth/Sad.svg": 7663,
	"./Mouth/Smile-1.svg": 3145,
	"./Mouth/Smile-2.svg": 1770,
	"./Mouth/Smile.svg": 943,
	"./Mouth/indifferent.svg": 8395,
	"./Mouth/open.svg": 1325,
	"./Nose/Curve.svg": 3812,
	"./Nose/Flat.svg": 598,
	"./Nose/Pointed.svg": 9992,
	"./Nose/Round.svg": 7113,
	"./Nose/tilt.svg": 9138,
	"./Shirt/Collared.svg": 6170,
	"./Shirt/Crew.svg": 4301,
	"./Shirt/Leisure.svg": 4971,
	"./Shirt/Open.svg": 6870,
	"./Shirt/chocker.svg": 9413
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7135;